import React, {createContext, useContext, useMemo} from 'react';

export type ProjectPageContextType = {
  projectId: string;
  projectName: string;
  projectEntityName: string;
};

export const ProjectPageContext = createContext<
  ProjectPageContextType | undefined
>(undefined);

type ProjectPageContextProviderProps = {
  project: {
    id: string;
    name: string;
    entityName: string;
  };
  children: React.ReactNode;
};

export const ProjectPageContextProvider = ({
  project,
  children,
}: ProjectPageContextProviderProps) => {
  const memoProject = useMemo(() => {
    return {
      projectId: project.id,
      projectName: project.name,
      projectEntityName: project.entityName,
    };
  }, [project.id, project.name, project.entityName]);
  return (
    <ProjectPageContext.Provider value={{...memoProject}}>
      {children}
    </ProjectPageContext.Provider>
  );
};

export const useProjectPageContext = () => {
  const context = useContext(ProjectPageContext);
  if (!context) {
    throw new Error(
      'useProjectPageContext must be used within a ProjectPageContextProvider'
    );
  }
  return context;
};
